import React from 'react';
import Card from '../shared/Card';
import Button from '../shared/Button';
import './CompleteView.css';

const CompleteView = ({ kernel, onReset }) => {
  const isAccepted = kernel.public_agent_decision === 'Yes';

  return (
    <div className="complete-view">
      <Card title="Assessment Complete">
        <div className="complete-view__content">
          {/* Main Decision Box */}
          <div className={`complete-view__decision ${isAccepted ? 'complete-view__decision--accepted' : 'complete-view__decision--rejected'}`}>
            <div className="complete-view__decision-icon">
              {isAccepted ? '✓' : '✗'}
            </div>
            <div className="complete-view__decision-content">
              {isAccepted ? (
                <>
                  <h3 className="complete-view__decision-title">Information Accepted</h3>
                  <p className="complete-view__decision-text">
                    Our agents have assessed your data and believe it may have trading value. 
                    You will be contacted and compensated according to the value produced.
                  </p>
                </>
              ) : (
                <>
                  <h3 className="complete-view__decision-title">Information Not Accepted</h3>
                  <p className="complete-view__decision-text">
                    Our agents have assessed your data and determined it does not contain 
                    sufficient novel or actionable information at this time. This may be because 
                    the information is already publicly available or lacks trading relevance.
                  </p>
                </>
              )}
            </div>
          </div>

          <div className="complete-view__footer">
            <Button onClick={onReset} variant="primary" fullWidth>
              Submit Another Belief
            </Button>
          </div>
        </div>
      </Card>

      {/* Demo Box */}
      <div className="complete-view__demo-box">
        <div className="complete-view__demo-header">
          <span className="complete-view__demo-label">For Demo Purposes Only</span>
        </div>
        <div className="complete-view__demo-content">
          {kernel.intake_agent_thoughts && (
            <div className="complete-view__demo-section">
              <h4 className="complete-view__demo-title">Intake Agent Assessment:</h4>
              <p className="complete-view__demo-text">{kernel.intake_agent_thoughts}</p>
            </div>
          )}
          {kernel.search_question && (
            <div className="complete-view__demo-section">
              <h4 className="complete-view__demo-title">Generated Search Question:</h4>
              <p className="complete-view__demo-text">{kernel.search_question}</p>
            </div>
          )}
          {kernel.public_agent_thoughts && (
            <div className="complete-view__demo-section">
              <h4 className="complete-view__demo-title">Public Agent Analysis:</h4>
              <p className="complete-view__demo-text">{kernel.public_agent_thoughts}</p>
            </div>
          )}
          {kernel.public_agent_decision && (
            <div className="complete-view__demo-section">
              <h4 className="complete-view__demo-title">Final Decision:</h4>
              <p className={`complete-view__demo-decision ${isAccepted ? 'complete-view__demo-decision--yes' : 'complete-view__demo-decision--no'}`}>
                {kernel.public_agent_decision}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompleteView;
